export default {
  record: {
    label: '録画プロジェクト',
    describe: 'オンラインでゲームの試遊とビデオの録画',
    guide: '查看録画操作ガイド',
    download: 'Mindworksプラグインをダウンロード',
    newcreate: '新規プロジェクト',
    filter: {
      projectname: 'プロジェクト名',
      versionname: 'バージョン名',
      projectid: 'プロジェクトID',
      versionid: 'バージョンID',
      search: '検索',
      projectstatus: 'プロジェクトステータス',
      uploaded: 'アップロード済み',
      waitingupload: 'アップロード待ち',
      versionstatus: 'バージョンステータス',
      editing: '編集中',
      exporting: 'エクスポート中',
      exported: 'エクスポート済み',
      exportfailed: 'エクスポート失敗',
      cancelled: 'キャンセル済み',
    },
    table: {
      nameid: 'プロジェクト/バージョン名およびID',
      operation: {
        name: '操作',
        createtips: 'バージョンを作成',
        lockedtips:
          '録画プロジェクトファイルはロックされています。クリックで解除できます。',
        locktips:
          '録画プロジェクトファイルは解除されています。クリックでロックできます。',
        copytips: 'コピー',
        edit: '編集',
        details: '詳細を見る',
        delete: '削除',
        exporthistory: 'エクスポート履歴',
      },
      productname: '製品名',
      parameters: 'パラメータ数',
      duration: 'バージョン時間',
      status: 'プロジェクト/バージョンステータス',
      createVersion: '新規プロジェクト作成',
      unlock: {
        label: 'このプロジェクトの録画プロジェクトファイルのロックを解除',
        describe:
          'Unity内の対応プロジェクトのゲームコンテンツを調整した場合、プロジェクト内の過去バージョンの内容が正常に表示されない可能性があります。',
      },
      copyproduct: 'プロジェクトをコピー',
      delete: {
        label: 'このプロジェクトを削除',
        describe:
          '録画プロジェクトを削除し、プロジェクト内のプロジェクトファイルおよびバージョンも一緒に削除します。<br/>このプロジェクトがプロジェクトファイルを同期中またはビデオをエクスポート中の場合、削除が失敗する可能性があります。<br/>削除後は元に戻せません。削除しますか？',
      },
      version: {
        delete: 'このバージョンを削除',
        describe: '削除後は元に戻せません。削除しますか？',
      },
    },
    createproject: '新規録画プロジェクト',
    editproject: '録画プロジェクトの詳細を編集',
    basic: {
      information: '基本情報',
      productName: 'プロモーション製品',
      productNameTips: 'プロジェクト名を入力してください',
      projectName: 'プロジェクト名',
      projectNameTips: 'プロジェクト名を入力してください',
      placeholder: 'バージョン名を入力してください',
      keywords: 'キーワードで検索して選択してください',
      adaptation: 'ゲームの画面向き',
      portrait: '縦向き',
      landscape: '横向き',
      describe:
        'より良いゲーム録画効果を確保するために、インポートしたいゲームの画面の向きを選択できます。',
      noProject: 'プロジェクトが選択できません',
      paramsEmptyTips:
        'パラメータが空です。後で使用するために「録画パラメータ管理」で新しいパラメータを作成できます。',
      parameters: {
        title: '録画パラメータ',
        describe:
          'プロジェクトに録画プロジェクトファイルがアップロードされている場合、新しい録画パラメータはすぐにバージョン編集ページで適用されません。新しいパラメータは、開発者が実装し、録画プロジェクトファイルが同期更新された後、バージョン編集ページでのみ適用されます。',
      },
      existing: '既存のプロジェクトからコピー',
      default: 'パラメータ辞書からコピー',
      new: '新しいパラメータ',
      total: '合計 {total} パラメータ',
      table: {
        name: '名前',
        achieve: 'パラメータの状態',
        describe:
          'Unityで定義されていないパラメータは削除後、元に戻すことはできません。削除しますか?',
        operation: '操作',
        delete:
          'Unityで定義されていないパラメータは削除後、元に戻すことはできません。削除してもよろしいですか？',
        note: '説明',
        selected: '選択済み',
        content: 'オプションの値',
        defaults: 'デフォルト値',
        hidetips: 'クリックで非表示にできます',
        showtips: 'クリックで表示できます',
      },
    },
    projectDrop: {
      recordPackage: '録画プロジェクトファイル',
      packageName: 'ファイル名',
      packageStatus: 'ステータス',
      packageStatus1: 'ロックされました',
      packageStatus2: 'ロックされていません',
      packageUpdateTime: '更新日時',
      packageSize: 'サイズ',
    },
    cover: {
      title: '録画パラメータが重複しています。',
      info: '選択したパラメータは既存のパラメータと同じ名前です。プロジェクトに追加できません。<br />既存のパラメータを編集ページに戻るか、右下の「スキップ」ボタンをクリックして既存の競合項目をスキップし、追加操作を続行してください。',
      info1: '重複する録画パラメータ',
      confirm: 'スキップ',
    },
    promotional: {
      create: '新しいプロモーション製品',
      producttype: '製品タイプ',
      platformtype: 'プラットフォームの種類',
      ios: {
        placeholder: 'Apple App Storeのリンクを入力してください',
      },
      android: {
        placeholder:
          'Google PlayまたはAndroidアプリストアのリンクを入力してください',
      },
      website: {
        placeholder: 'リンクを入力してください',
      },
    },
    existing: {
      select: '既存のプロジェクトから選択',
      placeholder: 'プロジェクト名またはIDを検索して選択してください',
      parameters: 'プロジェクトパラメータ',
      table: {
        name: '名前',
        note: '説明',
        type: 'パラメータタイプ',
        content: 'オプションの値',
        defaults: 'デフォルト値',
        emptyTips: '先に録画プロジェクトを選択してください',
      },
    },
    parameter: {
      select: 'パラメータ辞書から選択',
      placeholder: 'パラメータ名を検索',
    },
    select: {
      single: '単一選択',
      multiple: '複数選択',
      radio: '単一ドロップダウン',
      multi: '複数ドロップダウン',
      numvalue: '数値',
    },
    screen: {
      create: '新しい録画パラメータ',
      describe:
        'パラメータを編集した後、プラグインでプロジェクト情報をリフレッシュする必要があります。そうしないと、編集が失敗する可能性があります。',
      parametername: 'パラメータ名を入力してください',
      placeholder: 'パラメータ名を入力してください',
      description: '説明を入力してください',
      edit: '録画パラメータの編集',
      table: {
        sort: '並び替え',
        content: '内容',
        add: 'オプションの追加',
        tips: 'オプション値は少なくとも2つ必要です',
        tips1: 'デフォルト値に設定',
      },
      preview: 'プレビュー効果',
      option: '新しいオプション',
    },
    operation: {
      guide: {
        label: 'スクリーンレコーディングプロジェクトを素早く開始したいですか？',
        describe:
          '以下のガイドに従って、初めてのスクリーンレコーディングプロジェクトを作成してみてください！',
        step1: {
          label: '新しいスクリーンレコーディングプロジェクトを作成',
          describe:
            'スクリーンレコーディングパラメータを調整したい場合、プロジェクトを作成してください。',
          confirm: 'Mindworksプラグイン"がまだインストールされていませんか？',
          view: 'プラグインダウンロードガイド',
        },
        step2: {
          label:
            'UnityでMindworksプラグインにログインし、スクリーンレコーディングプロジェクト情報を確認します。',
          describe:
            'UnityでMindworksプラグインを使用して、スクリーンレコーディングプロジェクトファイルをPlayturboプラットフォームに同期します。',
        },
        step3: {
          label: 'オンライン録画、パラメータの調整',
          describe:
            'ゲームの録画をオンラインで行い、パラメータ設定を調整してさまざまなビデオを直接取得します。',
        },
        step4: {
          label: '編集を完了し、ビデオをエクスポート',
          describe: 'お疲れ様でした！',
        },
      },
    },
  },
}
